import { createActionNamespace } from 'Modules/core/redux';

import { MonitoringElement } from '../../api';


const monitoringAction = createActionNamespace('monitoring');


export const monitoringActions = {
    getMonitoringList: monitoringAction<void>('GET_MONITORING_LIST'),
    setMonitoringList: monitoringAction<MonitoringElement[]>('SET_MONITORING_LIST'),
};
